@if (loading.loading) {
  <div class="loader flex-column flex align-items-center" [ngClass]="{'full-background': loading.fullBackground}">
    <div class="loading-div w-30rem h-25rem flex-column flex align-items-center ">
      <h3 class="loading-title mt-7">{{loading.title}}</h3>
      @if (loading.type != 'progressbar') {
        <div #loadingspinner class="loadingspinner">
          <div id="square1"></div>
          <div id="square2"></div>
          <div id="square3"></div>
          <div id="square4"></div>
          <div id="square5"></div>
        </div>
      }
      @if (loading.type === 'progressbar') {
        <p-progressBar
          [showValue]="false"
          [value]="loading.value"
          styleClass="w-20rem h-1rem"
        ></p-progressBar>
      }
      @if (loading.type === 'progressbar') {
        <div class="p-bar">{{ loading.value }} %</div>
      }
      <div class="loading-subtitle mt-3">{{loading.message}}</div>
    </div>
  </div>
}